import * as React from 'react';
import { Typography, Grid2 as Grid } from '@mui/material';
import Heading from '../elements/heading';
import SubscriptionCard from '../elements/subscription-card';
import { UniqueSubscription } from '../../types/blocks/unique-subscription';
import { CallToActionButton } from '../elements/call-to-action-button';

interface SectionUniqueSubscriptionProps {
  element: UniqueSubscription;
}
export const SectionUniqueSubscription: React.FC<SectionUniqueSubscriptionProps> = ({
  element,
}) => (
  <div className="bg-paper py-24 pb-16 px-4 md:px-[40px] lg:px-[88px]">
    <div className="max-w-[1000px] mx-auto">
      <Heading title={element.title} subtitle={element.description} className="relative z-1" />

      <img src={element.image?.url} className="md:max-w-[482px] mt-[-10px] mx-auto" />
      <div className="max-w-[1000px] mx-auto relative z-1">
        <Grid
          container
          spacing={{ xs: 1, sm: 2 }}
          alignItems="stretch"
          className="mt-[-30px] mb-1 sm:mb-4"
        >
          <Grid size={{ xs: 12, sm: 6 }} className="flex-grow">
            <SubscriptionCard title="Catalogo" items={element.catalogList} className="h-full" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }} className="flex-grow">
            <SubscriptionCard title="Community" items={element.communityList} className="h-full" />
          </Grid>
        </Grid>

        <div
          className="md:min-h-[250px] rounded-2xl mx-auto overflow-hidden p-8 md:py-8 md:px-10 flex items-center relative"
          style={{ backgroundColor: '#7934CD' }}
        >
          <Grid container className="z-10" rowSpacing={1}>
            <Grid size={{ md: 6, lg: 8 }}>
              <Typography variant="title-mac-sans-xl" component="h4">
                {element.card.title}
              </Typography>
            </Grid>
            <Grid size={{ md: 6, lg: 4 }}>
              <div className="h-full flex items-center justify-end items-center">
                <CallToActionButton
                  button={element.card.callToAction}
                  textClassName="whitespace-nowrap"
                  sx={{
                    boxShadow: '0px 0px 0px 5px rgba(255, 255, 255, 0.20)',
                    flex: 'none',
                  }}
                />
              </div>
            </Grid>
          </Grid>
          <img src={element.card.image?.url} className="absolute left-0 h-full" />
        </div>
      </div>
    </div>
  </div>
);
